import { Component, OnInit } from '@angular/core';
import { EmitterService } from '../../../shared/services/emitter.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'mtm-zoom-in-out',
  templateUrl: './zoom-in-out.component.html',
  styleUrl: './zoom-in-out.component.scss',
  standalone: false,
})
export class ZoomInOutComponent implements OnInit {
  zoomLevel: number = 1;
  scrollOffset: number = 0; // Horizontal scroll offset
  isZoomInActive: boolean = false;
  isZoomOutActive: boolean = true; // Initially, zoom out is active
  zoomLevels: number[] = []; // Dropdown levels (10%, 20%, ..., 200%)
  // Update button states based on the zoom level
  previousZoomLevel: number = 1; // Initialize with default zoom level (or 1x in your case)
  // Dropdown levels
  selectedZoomPercentage: number = 100; // Default zoom percentage
  ngUnsubscribe = new Subject();

  ngOnInit() {
    this.initializeZoomLevels();
    this.checkOverflow();
  }

  initializeZoomLevels() {
    this.zoomLevels = Array.from({ length: 20 }, (_, i) => (i + 1) * 10); // Create levels [10, 20, ..., 200]
  }

  zoomIn() {
    this.zoomLevel = Math.min(2, this.zoomLevel + 0.1); // Increase zoom level with a maximum limit
    this.updateSlider(); // Update slider to match zoom level
    this.isZoomInActive = true;
    this.isZoomOutActive = false;
    this.updateDropdownValue(); // Sync dropdown with slider value
    EmitterService.get('zoomLevel').emit(this.zoomLevel);
  }

  zoomOut() {
    this.zoomLevel = Math.max(0.5, this.zoomLevel - 0.1); // Decrease zoom level with a minimum limit
    this.updateSlider(); // Update slider to match zoom level
    this.isZoomInActive = false;
    this.isZoomOutActive = true;
    this.updateDropdownValue(); // Sync dropdown with slider value
    EmitterService.get('zoomLevel').emit(this.zoomLevel);
  }

  onZoomChange(event: Event) {
    const sliderValue = (event.target as HTMLInputElement).value;
    this.zoomLevel = parseFloat(sliderValue); // Update zoom level from slider
    this.updateButtonStates();
    this.updateDropdownValue();
    EmitterService.get('zoomLevel').emit(this.zoomLevel);
  }

  zoomscrollLeft() {
    this.scrollOffset -= 100; // Adjust horizontal scroll offset
    this.updateScrollPosition();
  }

  zoomscrollRight() {
    this.scrollOffset += 100; // Adjust horizontal scroll offset
    this.updateScrollPosition();
  }

  updateScrollPosition() {
    const container = document.getElementById('mainContainer');
    if (container) {
      container.scrollLeft = this.scrollOffset;
    }
  }

  // Update the slider's value dynamically to reflect the current zoom level
  updateSlider() {
    const slider = document.getElementById('zoomSlider') as HTMLInputElement;
    if (slider) {
      slider.value = this.zoomLevel.toString();
    }
    this.updateDropdownValue(); // Sync dropdown with slider value
  }

  updateButtonStates() {
    // Compare previous and current zoom levels
    if (this.zoomLevel > this.previousZoomLevel) {
      // Zooming in
      this.isZoomInActive = true;
      this.isZoomOutActive = false;
    } else if (this.zoomLevel < this.previousZoomLevel) {
      // Zooming out
      this.isZoomInActive = false;
      this.isZoomOutActive = true;
    } else {
      // No change (both buttons can be active)
      this.isZoomInActive = true;
      this.isZoomOutActive = true;
    }

    // Update the previous zoom level after comparison
    this.previousZoomLevel = this.zoomLevel;
  }
  // Handle zoom level changes via dropdown
  onZoomDropdownChange(event: Event) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    this.zoomLevel = parseFloat(selectedValue) / 100; // Convert percentage to scale (e.g., 100% = 1)
    this.updateButtonStates();
    EmitterService.get('zoomLevel').emit(this.zoomLevel);
  }

  updateDropdownValue() {
    // Convert the zoom level to a percentage and round it to the nearest multiple of 10
    const percentage = Math.round(this.zoomLevel * 100);
    this.selectedZoomPercentage = Math.round(percentage / 10) * 10; // Snap to the nearest 10%
  }
  canZoomOut: boolean = true;
  checkOverflow() {
    EmitterService.get('isOverflow')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (level) => {
          this.canZoomOut = level;
        },
      });
  }
}
